module.exports = __webpack_public_path__ + "static/media/WaitingForCustomerConfirmation.d27ecfd2.svg";